export const MIN_LOAN_AMOUNT = 1000;
export const MAX_LOAN_AMOUNT = 47500;
